export default __webpack_public_path__ + "static/media/edit-score.810d1202.svg";